module.exports = __webpack_public_path__ + "img/4_1.a18e4da7.jpg";